// `excludeLicense`, when set, frees that license's own allocation back
// into the pool so editing a key shows the seats it could grow into — not
// just what other keys haven't claimed yet.
function usePlanCapacity(subscription, excludeLicense) {
    const installations = subscription.installations ?? [];
    const productionTotal = installations.reduce((sum, i)=>sum + (i.data.maxInstallationsProduction || 0), 0);
    const productionUsed = installations.reduce((sum, i)=>sum + (i.data.installationsProduction || 0), 0);
    const developmentTotal = installations.reduce((sum, i)=>sum + (i.data.maxInstallationsDevelopment || 0), 0);
    const developmentUsed = installations.reduce((sum, i)=>sum + (i.data.installationDevelopment || 0), 0);
    const excludeProduction = excludeLicense?.data.maxInstallationsProduction ?? 0;
    const excludeDevelopment = excludeLicense?.data.maxInstallationsDevelopment ?? 0;
    const productionFree = Math.max(0, productionTotal - productionUsed + excludeProduction);
    const developmentFree = Math.max(0, developmentTotal - developmentUsed + excludeDevelopment);
    return {
        productionTotal,
        productionUsed: productionUsed - excludeProduction,
        productionFree,
        isProductionExhausted: productionTotal > 0 && productionFree === 0,
        developmentTotal,
        developmentUsed: developmentUsed - excludeDevelopment,
        developmentFree,
        isDevelopmentExhausted: developmentTotal > 0 && developmentFree === 0
    };
}
export { usePlanCapacity };
